import React from "react";
import PdfBase from "./PdfBase";
import { generateRentalIncomePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  address,
  hasVacantPeriod,
  vacantPeriods,
  rentalPeriods,
  grossIncomeRows,
  expensesRows,
  totalGrossIncome,
  netRentalIncome,
  foreignTaxSettings,
  notes,
  reviewNotes,
  shareOfExpenses,
}) => {
  const sharedArgs = [
    schedule,
    company,
    address,
    hasVacantPeriod,
    vacantPeriods,
    rentalPeriods,
    grossIncomeRows,
    expensesRows,
    totalGrossIncome,
    netRentalIncome,
    foreignTaxSettings,
    notes,
    reviewNotes,
    shareOfExpenses,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateRentalIncomePdf(forView, ...sharedArgs)
        }
        downloadName='Rental Income Schedule'
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateRentalIncomePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
